<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('campusAttendance.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('campusAttendance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-1 form-group">
              <label></label>
              <ts-button
                outline
                class="ml-2 mt-4"
                v-tooltip="$t('campusAttendance.addManual')"
                color="info"
                @click="showForm"
              >
                {{ $t('add_new') }}
              </ts-button>
            </div>
            <div class="col-md-2 form-group">
              <label class="required">{{
                $t('campusAttendance.fromDate')
              }}</label>
              <ts-date-picker-input
                v-model="model.date_from"
                :closeOnSelect="true"
              ></ts-date-picker-input>
              <div class="validate" v-if="errors.has('date_from')">
                {{ errors.first('date_from') }}
              </div>
            </div>
            <div class="col-md-2 form-group">
              <label class="required">{{
                $t('campusAttendance.toDate')
              }}</label>
              <ts-date-picker-input
                v-model="model.date_to"
                :closeOnSelect="true"
              ></ts-date-picker-input>
              <div class="validate" v-if="errors.has('date_to')">
                {{ errors.first('date_to') }}
              </div>
            </div>
            <div class="col-md-4 text-left">
              <label></label>
              <ts-button
                class="mt-4 ts-mr-3"
                color="success"
                :waiting="exporting"
                @click.prevent="exportExcel"
                >{{ $t('excel') }}</ts-button
              >
              <label></label>
              <ts-button
                @click="onTypeChange"
                class="mt-4"
                color="primary"
                :waiting="loading"
                >{{ $t('view') }}</ts-button
              >
            </div>

            <div class="col-md-3 text-right ts-flex">
              <label></label>
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 350px"
                class="inline-block ts-mt-8"
              />
              <ts-button
                outline
                class="ml-2 ts-mt-8 ts-mb-8"
                v-tooltip="$t('filter')"
                @click.prevent="visible = true"
              >
                <i class="fa fa-filter"></i>
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <a-tabs v-model:activeKey="model.type" @change="onTypeChange">
          <a-tab-pane key="summary">
            <template #tab>
              <span> Summary </span>
            </template>
            <ts-loading-banner :loading="loading">
              <summary-report
                ref="summary"
                v-model="model"
                :validate="errors"
              ></summary-report>
            </ts-loading-banner>
          </a-tab-pane>
          <a-tab-pane key="detail">
            <template #tab>
              <span> Detail </span>
            </template>
            <ts-loading-banner :loading="loading">
              <detail @fetch="onTypeChange"></detail>
            </ts-loading-banner>
          </a-tab-pane>
        </a-tabs>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination
            v-model="pagination"
            @navigate="onTypeChange"
          ></ts-pagination>
        </div>
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="400px"
        >
          <ts-loading-banner :loading="loadingFilter">
            <div class="ts-space-y-3">
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.branchName') }}</label>
                  <div class="form-group ts-w-full">
                    <a-select
                      style="width: 100%"
                      v-model="branch_id"
                      :options="branchs"
                      showSearch
                      mode="multiple"
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      :maxTagCount="1"
                      :maxTagTextLength="17"
                      :placeholder="$t('all')"
                      @change="changeBranch()"
                    >
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.mainProgram') }}</label>
                  <a-select
                    v-model="model.acp_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :max-tag-text-length="10"
                    :options="mainProgramOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onChangeMainProgram"
                  ></a-select>
                  <div class="validate" v-if="errors.has('acp_id')">
                    {{ errors.first('acp_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.subProgram') }}</label>
                  <a-select
                    v-model="model.acps_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :max-tag-text-length="10"
                    :options="subProgramOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onChangeSubProgram"
                  ></a-select>
                  <div class="validate" v-if="errors.has('acps_id')">
                    {{ errors.first('acps_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.acYear') }}</label>
                  <a-select
                    v-model="model.ac_year_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :options="academicYearOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onChangeAcYear"
                  ></a-select>
                  <div class="validate" v-if="errors.has('class_id')">
                    {{ errors.first('class_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.acTerm') }}</label>
                  <a-select
                    v-model="model.ac_term_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :options="academicTermOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onChangeAcTerm"
                  ></a-select>
                  <div class="validate" v-if="errors.has('class_id')">
                    {{ errors.first('class_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.acStudyTime') }}</label>
                  <a-select
                    v-model="model.ac_st_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :options="studyTimeOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onChangeAcStudyTime"
                  ></a-select>
                  <div class="validate" v-if="errors.has('class_id')">
                    {{ errors.first('class_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.className') }}</label>
                  <a-select
                    v-model="model.class_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :max-tag-text-length="10"
                    :options="classRoomsOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onChangeClass"
                  ></a-select>
                  <div class="validate" v-if="errors.has('class_id')">
                    {{ errors.first('class_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.studentName') }}</label>
                  <a-select
                    v-model="model.student_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :max-tag-text-length="10"
                    :options="studentListOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  ></a-select>
                  <div class="validate" v-if="errors.has('student_id')">
                    {{ errors.first('student_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('inactiveStudent.studentStatus') }}</label>
                  <a-select
                    v-model="model.status_id"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('all')"
                    :max-tag-count="1"
                    :max-tag-text-length="10"
                    :options="studentStatuOption"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  ></a-select>
                  <div class="validate" v-if="errors.has('status_id')">
                    {{ errors.first('status_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label>{{ $t('campusAttendance.attendanceStatus') }}</label>
                  <a-select
                    v-model="model.attendance_status"
                    style="width: 100%"
                  >
                    <a-select-option :value="0">All</a-select-option>
                    <a-select-option :value="1">Yes</a-select-option>
                    <a-select-option :value="2">No</a-select-option>
                  </a-select>
                  <div class="validate" v-if="errors.has('status_id')">
                    {{ errors.first('status_id') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 ts-text-right">
                  <ts-button
                    class="ts-mr-3"
                    color="success"
                    :waiting="exporting"
                    @click.prevent="exportExcel"
                    >{{ $t('excel') }}</ts-button
                  >
                  <ts-button
                    @click="onTypeChange"
                    color="primary"
                    :waiting="loading"
                    >{{ $t('view') }}</ts-button
                  >
                </div>
              </div>
            </div>
          </ts-loading-banner>
        </a-drawer>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { debounce, trim } from 'lodash'
import * as FileDownload from 'downloadjs'
import FormComponent from './form'
import EditComponent from './edit'
import Detail from './components/detail.vue'
import SummaryReport from './components/summary.vue'

export default {
  name: 'campusAttendance',
  components: { Detail, SummaryReport },
  data () {
    return {
      loading: false,
      loadingFilter: false,
      exporting: false,
      model: {
        date_from: moment().format('DD-MM-YYYY'),
        date_to: moment().format('DD-MM-YYYY'),
        acp_id: [],
        acps_id: [],
        ac_year_id: [],
        ac_term_id: [],
        class_id: [],
        all_class_id: [],
        student_id: [],
        status_id: [1],
        type: 'summary',
        attendance_status: 0
      },
      branchs: [],
      mainPrograms: [],
      subPrograms: [],
      classRooms: [],
      studentLists: [],
      studentStatus: [],
      headers: [],
      branch_id: [],
      academicYears: [],
      academicTerms: [],
      studyTimes: [],
      visible: false,
      errors: new Errors()
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchResource()
  },
  computed: {
    ...mapState('campusAttendance', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.campusAttendance.search
      },
      set (newValue) {
        this.$store.commit('campusAttendance/SET_SEARCH', newValue)
        this.$store.commit('campusAttendance/RESET_CURRENT_PAGE')
      }
    },
    mainProgramOption () {
      if (!this.mainPrograms) return []
      return this.mainPrograms.map(el => ({
        label: el.acp_name_foreign,
        value: el.acp_id
      }))
    },
    subProgramOption () {
      if (!this.subPrograms) return []
      return this.subPrograms.map(el => ({
        label: el.acps_name_foreign,
        value: el.acps_id
      }))
    },
    academicYearOption () {
      if (!this.academicYears) return []
      return this.academicYears.map(el => ({
        value: el.ac_year_id,
        label:
          el.ac_year +
          (el.ac_status_id == 1
            ? ' ( Current ) '
            : el.ac_status_id == 2
            ? ' ( History ) '
            : ' ( Next ) ') +
          '|' +
          el.branch.branch_name_en
      }))
    },
    academicTermOption () {
      if (!this.academicTerms) return []
      return this.academicTerms.map(el => ({
        value: el.ac_term_id,
        label:
          el.term_name +
          (el.ac_status_id == 1
            ? ' ( Current ) '
            : el.ac_status_id == 2
            ? ' ( History ) '
            : '( Next )') +
          '|' +
          el.branch.branch_name_en
      }))
    },
    studyTimeOption () {
      if (!this.studyTimes) return []
      return this.studyTimes.map(el => ({
        value: el.ac_st_id,
        label: el.study_time + '|' + el.session
      }))
    },
    classRoomsOption () {
      if (!this.classRooms) return []
      return this.classRooms.map(el => ({
        label:
          el.class_name +
          ' | ' +
          (el.academic_study_time
            ? el.academic_study_time.study_time +
              ' | ' +
              el.academic_study_time.session +
              ' | '
            : '') +
          (el.teacher ? el.teacher.full_name_en : ''),
        value: el.class_id
      }))
    },
    studentListOption () {
      if (!this.studentLists) return []
      return this.studentLists.map(el => ({
        value: el.student_id,
        label: el.full_name_en + '|' + el.full_name_kh
      }))
    },
    studentStatuOption () {
      if (!this.studentStatus) return []
      return this.studentStatus.map(el => ({
        value: el.status_id,
        label: el.status
      }))
    }
  },
  methods: {
    ...mapActions('campusAttendance', [
      'fetchMainProgram',
      'fetchSubProgram',
      'fetchClasses',
      'fetchStudents',
      'getStudentStatus',
      'getYear',
      'getTerm',
      'getStudyTime'
    ]),
    //get resource first time when enter
    async fetchResource () {
      this.loadingFilter = true
      this.loading = true
      this.mainPrograms = []
      this.classRooms = []
      this.studentLists = []
      this.studentStatus = []
      this.academicYears = []
      this.academicTerms = []
      this.studyTimes = []

      //Get Branch
      await this.$store
        .dispatch('user/getBranch')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      //Get Main Program
      await this.fetchMainProgram().then(response => {
        this.mainPrograms = response.data
      })

      //Get Academic Year
      await this.getYear({
        filter: {
          ac_status_id: '1,2',
          branch_id: this.branch_id
        },
        branch_id: this.branch_id
      }).then(response => {
        this.academicYears = response.data
        const academic_year = []
        this.academicYears.map(el => {
          if (el.ac_status_id == 1) {
            academic_year.push(el.ac_year_id)
          }
        })
        this.model.ac_year_id = academic_year.length > 0 ? academic_year : []
      })

      //Get Academic Term
      await this.getAcTerm()

      //Get Class
      await this.getClasses()

      //Get Student Status
      await this.getStudentStatus().then(response => {
        this.studentStatus = response.data
      })

      //Get StudyTime
      await this.getStudyTime().then(response => {
        this.studyTimes = response.data
      })
      this.loadingFilter = false
      this.loading = false
    },

    async getSubProgram () {
      this.subPrograms = []
      let response = await this.fetchSubProgram({ acp_id: this.model.acp_id })
      this.subPrograms = response.data
    },

    async getAcTerm () {
      this.academicTerms = []
      let response = await this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,2',
          ac_year_id: this.model.ac_year_id,
          branch_id: this.branch_id
        },
        branch_id: this.branch_id
      })
      this.academicTerms = response.data
      const academic_terms = []
      this.academicTerms.map(el => {
        if (el.ac_status_id == 1) {
          academic_terms.push(el.ac_term_id)
        }
      })
      // this.model.ac_term_id = academic_terms.length > 0 ? academic_terms : []
    },

    async getClasses () {
      this.classRooms = []
      let response = await this.fetchClasses({
        filter: {
          acp_id: this.model.acp_id,
          acps_id: this.model.acps_id,
          ac_term_id: this.model.ac_term_id,
          ac_status_id: '1,2',
          ac_year_id: this.model.ac_year_id,
          ac_st_id: this.model.ac_st_id,
          branch_id: this.branch_id
        },
        branch_id: this.branch_id
      })
      this.classRooms = response.data
      // this.model.all_class_id = response.data.map(el => el.class_id) // close coz error in asean
    },

    //when Change branch we need to get academic year, term, class by branch_id
    async changeBranch () {
      this.loadingFilter = true
      this.loading = true
      await this.getYear({
        filter: {
          ac_status_id: '1,2',
          branch_id: this.branch_id
        },
        branch_id: this.branch_id
      }).then(response => {
        this.academicYears = response.data
        const academic_year = []
        this.academicYears.map(el => {
          if (el.ac_status_id == 1) {
            academic_year.push(el.ac_year_id)
          }
        })
        this.model.ac_year_id = academic_year.length > 0 ? academic_year : []
      })
      await this.getAcTerm()

      await this.getClasses()

      await this.onTypeChange()

      this.loadingFilter = false
      this.loading = false
    },
    async onChangeMainProgram () {
      this.getSubProgram()
      await this.getClasses()
    },
    async onChangeSubProgram () {
      await this.getAcTerm()
      await this.getClasses()
    },
    async onChangeAcYear () {
      await this.getAcTerm()
      await this.getClasses()
    },
    async onChangeAcTerm () {
      await this.getClasses()
    },
    async onChangeAcStudyTime () {
      await this.getClasses()
    },
    async onChangeClass () {
      this.studentLists = []
      let response = await this.fetchStudents({
        acps_id: this.model.acps_id,
        class_id: this.model.class_id
      })
      this.studentLists = response.data
    },

    onTypeChange (attributes) {
      if (this.model.type == 'summary') {
        this.$refs.summary.getHeader()
        this.fetchDataSummary(attributes)
      } else {
        this.fetchDataDetail()
      }
    },
    fetchDataDetail (attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'campusAttendance/fetch',
          Object.assign(
            {},
            this.model,
            { branch_id: this.branch_id },
            attributes
          )
        )
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    fetchDataSummary (attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'campusAttendance/fetchSummary',
          Object.assign(
            {},
            this.model,
            { branch_id: this.branch_id },
            attributes
          )
        )
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    exportExcel (attributes) {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch(
          'campusAttendance/exportExcel',
          Object.assign(
            {},
            this.model,
            { branch_id: this.branch_id },
            attributes
          )
        )
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    showForm (data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    edit (data) {
      this.$modal.show(
        EditComponent,
        {
          editData: data
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchDataDetail({ search })
      this.fetchDataSummary({ search })
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
#table-container {
  min-height: 60vh;
  overflow-y: scroll;
}

table > tbody > tr td {
  vertical-align: middle;
}

.table > thead > tr > th {
  border: 1px solid #b6c2c9;
  vertical-align: middle;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: #ffff;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
